<template>
  <b-modal
    id="edit-lead-details-modal"
    ref="editLeadDetailsModalRef"
    size="lg"
    title="Editar detalhes do lead"
    @ok="handleOk"
    :busy="busyButton"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div
        style="display: flex; flex-direction: column; gap: 2rem; width: 100%;"
      >
        <div style="display: flex; gap: 2rem; width: 100%;">
          <GenericTextInput
            v-model="leadDetailsForm.UCNumber"
            style="width: 25%;"
            label="*Número da UC"
            inputId="uc-number"
            :required="true"
            :validationFunc="validateTextNotEmpty"
            :state="validStates.UCNumber"
            invalidFeedback="Por favor, insira um número da UC válido."
            @validation-updated="validStates.UCNumber = $event"
          />

          <GenericTextInput
            v-model="leadDetailsForm.holderName"
            style="width: 75%;"
            label="*Nome do titular"
            inputId="holder-name"
            :required="true"
            :validationFunc="validateTextNotEmpty"
            :state="validStates.holderName"
            invalidFeedback="Por favor, insira um nome."
            @validation-updated="validStates.holderName = $event"
          />
        </div>

        <div style="display: flex; gap: 2rem; width: 100%;">
          <SCEEPowerSelect
            v-model="leadDetailsForm.hasSCEEPower"
            style="width: 25%;"
            label="Tem energia SCEE?"
            inputId="scee-power"
            :required="true"
            :validationFunc="validateTextNotEmpty"
            :state="validStates.hasSCEEPower"
            invalidFeedback="Por favor, selecione uma opção."
            @validation-updated="validStates.hasSCEEPower = $event"
          />

          <b-form-group
            label="Tem conta em atraso?"
            label-for="late-bill"
            style="width: 25%;"
          >
            <b-form-checkbox
              id="late-bill"
              :checked="Boolean(leadDetailsForm.hasLateBill)"
              v-model="leadDetailsForm.hasLateBill"
              size="sm"
            />
          </b-form-group>

          <GenericTextInput
            v-model="leadDetailsForm.kwhTotalConsumption"
            style="width: 25%;"
            label="*Consumo total (kWh)"
            inputId="kwh-total-consumption"
            :required="true"
            :validationFunc="validateTextNotEmpty"
            :state="validStates.kwhTotalConsumption"
            invalidFeedback="Por favor, insira o consumo total em kWh."
            @validation-updated="validStates.kwhTotalConsumption = $event"
          />

          <GenericTextInput
            v-model="leadDetailsForm.numberOfActiveUCs"
            style="width: 25%;"
            label="*Número de UC ativas"
            inputId="number-of-active-ucs"
            :required="true"
            :validationFunc="validateTextNotEmpty"
            :state="validStates.numberOfActiveUCs"
            invalidFeedback="Por favor, insira a quantidade de UC ativas."
            @validation-updated="validStates.numberOfActiveUCs = $event"
          />
        </div>

        <div style="display: flex; gap: 2rem; width: 100%;">
          <PhoneInput
            style="width: 25%;"
            v-model="leadDetailsForm.phonePCFA"
            :state="validStates.phonePCFA"
            @validation-updated="validStates.phonePCFA = $event"
          />
          <EmailInput
            style="width: 75%;"
            v-model="leadDetailsForm.emailPCFA"
            :state="validStates.emailPCFA"
            @validation-updated="validStates.emailPCFA = $event"
          />
        </div>

        <b-form-group
          label="Observação"
          label-for="observation"
          style="width: 100%;"
        >
          <b-form-textarea
            id="observation"
            v-model="leadDetailsForm.observation"
            placeholder="Observação"
            debounce="1000"
            rows="3"
            max-rows="6"
            style="border-radius: 4px; outline: none; border: 1px solid grey;"
          />
        </b-form-group>
      </div>
    </form>
  </b-modal>
</template>

<script>
import {
  PhoneInput,
  EmailInput,
  GenericTextInput,
} from '../../../../ui/inputs';
import { SCEEPowerSelect } from '../';
import { Api } from '../../../../vue/api';
const API = new Api();

export default {
  name: 'EditLeadDetailsModal',
  components: {
    GenericTextInput,
    SCEEPowerSelect,
    PhoneInput,
    EmailInput,
  },
  data() {
    return {
      leadDetailsForm: {
        UCNumber: '',
        holderName: '',
        hasSCEEPower: '',
        hasLateBill: false,
        kwhTotalConsumption: '',
        numberOfActiveUCs: '',
        phonePCFA: '',
        emailPCFA: '',
        observation: '',
      },
      validStates: {
        UCNumber: null,
        holderName: null,
        hasSCEEPower: null,
        kwhTotalConsumption: null,
        numberOfActiveUCs: null,
        phonePCFA: null,
        emailPCFA: null,
      },
      busyButton: false,
    };
  },
  methods: {
    validateTextNotEmpty(value) {
      return value.trim().length > 0;
    },
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, { title, variant, solid: true });
    },
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      await this.handleSubmit();
    },
    openModal(lead) {
      this.leadDetailsForm = lead;
      this.$refs.editLeadDetailsModalRef.show();
    },
    allValid() {
      return Object.values(this.validStates).every(status => status);
    },
    async handleSubmit() {
      if (!this.allValid()) {
        Object.keys(this.validStates).forEach(key => {
          if (this.validStates[key] !== true) {
            this.validStates[key] = false;
          }
        });
        this.showToast(
          'Preencha todos os campos obrigatórios corretamente!',
          'Erro',
          'danger',
        );
        return;
      }
      try {
        this.busyButton = true;
        const { model, ok, errors } = await API.post('/execute', {
          path: `/lead-management/qualified-leads/update-info`,
          method: 'post',
          data: { lead: this.leadDetailsForm },
        });
        if (!ok) {
          throw new Error(
            (errors && errors.message) ||
              'Não foi possível atualizar os dados do lead',
          );
        }
        this.$emit('updateLeadInTable', model);
        this.showToast('Dados atualizados com sucesso!', 'Sucesso', 'success');
      } catch (error) {
        this.showToast(error.message, 'Erro', 'danger');
      } finally {
        this.$refs.editLeadDetailsModalRef.hide('edit-lead-details-modal');
        this.busyButton = false;
      }
    },
  },
};
</script>
